<template>
  <div class="activity-404">
    <div class="activity-404-img">
      <img src="../../assets/imgs/activity_404.png" />
    </div>
    <div class="activity-404-label" v-html="'页面可能出国旅游了~(>_<)~'"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.activity-404 {
  padding-top: 0.5rem;
  .activity-404-img {
    text-align: center;
    img {
      width: 2rem;
      height: 2rem;
    }
  }
  .activity-404-label {
    text-align: center;
    font-size: 0.14rem;
    color: #aaaaaa;
  }
}
</style>
